<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="100px">
      <el-form-item label="类型">
        <el-radio-group v-model="radio" @change="typeradio">
          <el-radio :label="1">投手</el-radio>
          <el-radio :label="2">绑定关系</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radio === 2" label="绑定关系">
        <div>
          <el-autocomplete
            v-model="app_id"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择绑定关系"
            @clear="(app_id = null)"
            @select="handleSelect"
          />
        </div>
      </el-form-item>
      <el-form-item label="配置参数">
        <div>
          <div>ROI达标率<span class="dawpr">（*范围0-100）</span></div>
          <div class="dawe_box">
            <div v-for="item,index in arr" :key="index" class="roibox">
              <el-input v-model="item.value_min" placeholder="值大于等于" style="width:100px;" type="number" />
              <div style="margin:0 5px">-</div>
              <el-input v-model="item.value_max" placeholder="值小于" style="width:100px" type="number" />
              <el-time-picker
                v-model="item.time"
                style="margin:0 10px"
                is-range
                format="HH:mm"
                value-format="HH:mm"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                :clearable="false"
              />
              <el-button type="primary" @click="add(item)">+</el-button>
              <el-button v-if="index!=0" type="primary" @click="reduce(index)">-</el-button>
            </div>
          </div>

          <!-- <div class="subr">
            <el-radio-group v-model="operatorradio">
              <el-radio :label="'>='">大于等于</el-radio>
              <el-radio :label="'<='">小于等于</el-radio>
            </el-radio-group>
          </div>
          <div><el-input v-model="roival" placeholder="请输入ROI数值" style="width:130px" type="number" @blur="rednum" /></div> -->
        </div>
        <div>
          <div>新用户ROI<span class="dawpr">（*范围0-100）</span></div>
          <div class="dawe_box">
            <div v-for="item,index in arrone" :key="index" class="roibox">
              <el-input v-model="item.value_min" placeholder="值大于等于" style="width:100px" type="number" />
              <div style="margin:0 5px">-</div>
              <el-input v-model="item.value_max" placeholder="值小于" style="width:100px;" type="number" />
              <el-time-picker
                v-model="item.time"
                style="margin:0 10px"
                is-range
                format="HH:mm"
                value-format="HH:mm"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                :clearable="false"
              />
              <el-button type="primary" @click="addone(item)">+</el-button>
              <el-button v-if="index!=0" type="primary" @click="reduceone(index)">-</el-button>
            </div>
          </div>
          <!-- <div class="subr">
            <el-radio-group v-model="newoperatorradio">
              <el-radio :label="'>='">大于等于</el-radio>
              <el-radio :label="'<='">小于等于</el-radio>
            </el-radio-group>
          </div>
          <div><el-input v-model="newroival" placeholder="请输入ROI数值" style="width:130px" type="number" @blur="rednumone" /></div>
          <div class="dawpr">*范围0-100</div> -->
        </div>
        <div>
          <div>付费增长率<span class="dawpr">（*范围0-100）</span></div>
          <div class="dawe_box">
            <div v-for="item,index in arrthree" :key="index" class="roibox">
              <el-input v-model="item.value_min" placeholder="值大于等于" style="width:100px" type="number" />
              <div style="margin:0 5px">-</div>
              <el-input v-model="item.value_max" placeholder="值小于" style="width:100px;" type="number" />
              <el-time-picker
                v-model="item.time"
                style="margin:0 10px"
                is-range
                format="HH:mm"
                value-format="HH:mm"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                :clearable="false"
              />
              <el-button type="primary" @click="addtwo(item)">+</el-button>
              <el-button v-if="index!=0" type="primary" @click="reducetwo(index)">-</el-button>
            </div>
          </div>

          <!-- <div class="subr">
            <el-radio-group v-model="payoperatorradio">
              <el-radio :label="'>='">大于等于</el-radio>
              <el-radio :label="'<='">小于等于</el-radio>
            </el-radio-group>
          </div>
          <div><el-input v-model="payroival" placeholder="请输入增长率" style="width:130px" type="number" @blur="rednumtwo" /></div>
          <div class="dawpr">*范围0-100</div> -->
        </div>
      </el-form-item>
      <el-form-item label="是否通知组长">
        <div>
          <el-radio-group v-model="grounpradio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="是否电话通知">
        <div>
          <el-radio-group v-model="is_call">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item>
        <div>
          <el-button type="primary" @click="sumbit">确定</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { getBindingRelationList, bindthresholdconfigs, editbindthresholdconfigs } from '@/api/releaseGroup.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      pageinfo: {
        page: 1,
        page_size: 10
      },
      app_id: null,
      app_ids: null,
      radio: 1,
      operatorradio: '>=',
      roival: '',
      newoperatorradio: '>=',
      newroival: '',
      payoperatorradio: '>=',
      payroival: '',
      grounpradio: 1,
      type: null,
      id: null,
      is_call: 1,
      arr: [{
        desc: 'ROI达标率',
        field: 'compliance_rate',
        time: ['08:40', '09:40'],
        start_hi: '',
        end_hi: '',
        value_max: '',
        value_min: ''
      }],
      arrone: [{
        desc: '新用户ROI',
        field: 'new_user_roi',
        time: ['08:40', '09:40'],
        start_hi: '',
        end_hi: '',
        value_max: '',
        value_min: ''
      }],
      arrthree: [{
        desc: '付费增长率',
        field: 'payment_growth_rate',
        time: ['08:40', '09:40'],
        start_hi: '',
        end_hi: '',
        value_max: '',
        value_min: ''
      }],
      arw: [],
      arwtwo: [],
      arwthree: []
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    add(item) {
      this.arr.push({
        desc: 'ROI达标率',
        field: 'compliance_rate',
        time: item.time,
        start_hi: '',
        end_hi: '',
        value_max: item.value_max,
        value_min: item.value_min
      })
    },
    reduce(index) {
      this.arr.splice(index, 1)
    },
    addone(item) {
      this.arrone.push({
        desc: '新用户ROI',
        field: 'new_user_roi',
        time: item.time,
        start_hi: '',
        end_hi: '',
        value_max: item.value_max,
        value_min: item.value_min
      })
    },
    reduceone(index) {
      this.arrone.splice(index, 1)
    },
    addtwo(item) {
      this.arrthree.push({
        desc: '付费增长率',
        field: 'payment_growth_rate',
        time: item.time,
        start_hi: '',
        end_hi: '',
        value_max: item.value_max,
        value_min: item.value_min
      })
    },
    reducetwo(index) {
      this.arrthree.splice(index, 1)
    },
    send(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (this.type == 2) {
        this.radio = item.type
        this.grounpradio = item.is_notice_leader
        this.is_call = item.is_call
        console.log(' JSON.parse(item.config_json)', item.config_json)
        // this.operatorradio = JSON.parse(item.config_json)[0].operator
        // this.roival = JSON.parse(item.config_json)[0].values
        // this.newoperatorradio = JSON.parse(item.config_json)[1].operator
        // this.newroival = JSON.parse(item.config_json)[1].values
        // this.payoperatorradio = JSON.parse(item.config_json)[2].operator
        // this.payroival = JSON.parse(item.config_json)[2].values
        item.config_json.forEach(element => {
          if (element.field === 'compliance_rate') {
            this.arw.push({ ...element, time: [element.start_hi, element.end_hi] })
          }
          if (element.field === 'new_user_roi') {
            this.arwtwo.push({ ...element, time: [element.start_hi, element.end_hi] })
          }
          if (element.field === 'payment_growth_rate') {
            this.arwthree.push({ ...element, time: [element.start_hi, element.end_hi] })
          }
        })

        console.log('this.arw', this.arw)
        this.arr = this.arw
        this.arrone = this.arwtwo
        this.arrthree = this.arwthree

        console.log(this.arw, this.arwtwo, this.arwthree)
        // eslint-disable-next-line eqeqeq
        if (item.type == 2) {
          this.app_id = JSON.parse(item.wechat_names).join(',')
          this.app_ids = item.bind_wechat_id
        }
      }
      this.id = item.id
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === '') {
        this.app_id = null
        this.app_ids = null
      }
      const data = await getBindingRelationList({ ...this.pageinfo, app_id: this.app_id })
      const newArr = data.data.list.map((item) => {
        return { ...item, value: item.wechat_names.join(','), address: item.id }
      })
      cb(newArr)
    },
    handleSelect(val) {
      this.app_ids = val.id
      console.log(val)
    },
    typeradio(val) {
      console.log('val', val)
      if (val === 1) {
        this.app_id = null
        this.app_ids = null
      }
    },
    rednum() {
      // eslint-disable-next-line eqeqeq
      if (this.roival < 0 && this.roival != '') {
        this.roival = 0
      }
      // eslint-disable-next-line eqeqeq
      if (this.roival > 100 && this.roival != '') {
        this.roival = 100
      }
      // 判断不能输入小数点
      const str = '' + this.roival
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.roival = 0
      }
    },
    rednumone() {
      // eslint-disable-next-line eqeqeq
      if (this.newroival < 0 && this.newroival != '') {
        this.newroival = 0
      }
      // eslint-disable-next-line eqeqeq
      if (this.newroival > 100 && this.newroival != '') {
        this.newroival = 100
      }
      // 判断不能输入小数点
      const str = '' + this.newroival
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.newroival = 0
      }
    },
    rednumtwo() {
      // eslint-disable-next-line eqeqeq
      if (this.payroival < 0 && this.payroival != '') {
        this.payroival = 0
      }
      // eslint-disable-next-line eqeqeq
      if (this.payroival > 100 && this.payroival != '') {
        this.payroival = 100
      }
      // 判断不能输入小数点
      const str = '' + this.payroival
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.payroival = 0
      }
    },
    async sumbit() {
      // console.log(this.arr)
      if (this.radio === 2) {
        if (this.app_ids === null) {
          this.$message({
            message: '请选择正确的绑定关系',
            type: 'error'
          })
          return
        }
      }
      // if (this.roival === '') {
      //   this.$message({
      //     message: '请输入ROI达标率',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (this.newroival === '') {
      //   this.$message({
      //     message: '请输入新用户ROI',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (this.payroival === '') {
      //   this.$message({
      //     message: '请输入付费增长率',
      //     type: 'error'
      //   })
      //   return
      // }
      // const arr = [{
      //   field: 'compliance_rate',
      //   values: this.roival,
      //   operator: this.operatorradio
      // }, {
      //   field: 'new_user_roi',
      //   values: this.newroival,
      //   operator: this.newoperatorradio
      // }, {
      //   field: 'payment_growth_rate',
      //   values: this.payroival,
      //   operator: this.payoperatorradio
      // }]
      const newArr = this.arr.map((item) => {
        return { desc: item.desc, field: item.field, start_hi: item.time[0], end_hi: item.time[1], value_max: item.value_max, value_min: item.value_min }
      })
      const newArrtwo = this.arrone.map((item) => {
        return { desc: item.desc, field: item.field, start_hi: item.time[0], end_hi: item.time[1], value_max: item.value_max, value_min: item.value_min }
      })
      const newArrthree = this.arrthree.map((item) => {
        return { desc: item.desc, field: item.field, start_hi: item.time[0], end_hi: item.time[1], value_max: item.value_max, value_min: item.value_min }
      })
      // const arr1 = arr.map(x => x.value_max)
      // const arr2 = arr.map(x => x.value_min)
      // console.log('arr', arr, newArr, newArrtwo, newArrthree)
      if (newArr[0].value_max === '' || newArrtwo[0].value_max === '' || newArrthree[0].value_max === '' || newArr[0].value_min === '' || newArrtwo[0].value_min === '' || newArrthree[0].value_min === '') {
        this.$message({
          message: '请配置所有参数！',
          type: 'error'
        })
        return
      } else {
        var arr = [...newArr, ...newArrtwo, ...newArrthree]
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        const data = await bindthresholdconfigs({
          type: this.radio,
          bind_wechat_id: this.app_ids,
          config_json: arr,
          is_notice_leader: this.grounpradio,
          is_call: this.is_call
        })
        this.$emit('updata')
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        console.log(this.app_id, this.app_ids, data)
      } else {
        const data = await editbindthresholdconfigs(this.id, {
          type: this.radio,
          bind_wechat_id: this.app_ids,
          config_json: arr,
          is_notice_leader: this.grounpradio,
          is_call: this.is_call
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updata')
        console.log(this.app_id, this.app_ids, data)
      }
    }
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
.set_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.subr{
  margin: 0 10px;
}
/deep/ .el-input__inner::-webkit-outer-spin-button,
 /deep/ .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
/deep/ .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }
 .dawpr{
  margin-left: 10px;
  color: red;
 }
 .roibox{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
 }
 .dawe_box{
    max-height: 130px;
    overflow: hidden;
    overflow-y: scroll;
 }
</style>
